import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Dashboard.css';

const Dashboard: React.FC = () => {
  const [userName, setUserName] = useState('');
  
  useEffect(() => {
    // Kullanıcı bilgilerini al
    const userStr = sessionStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        setUserName(`${user.ADI || ''} ${user.SOYADI || ''}`);
      } catch (err) {
        console.error('Kullanıcı bilgileri çözümlenemedi:', err);
      }
    }
  }, []);
  
  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1>İstanbul Havalimanı Taksi Kooperatifi</h1>
        <p>Hoşgeldiniz, {userName || 'Üye'}</p>
      </header>
      
      <div className="menu-container">
        <Link to="/plaka-listesi" className="menu-item">
          <div className="menu-text">Plaka Listesi</div>
        </Link>
        
        <Link to="/tahsilatlar" className="menu-item">
          <div className="menu-text">Tahsilatlar</div>
        </Link>
      </div>
      
      <footer className="dashboard-footer">
        <p>© {new Date().getFullYear()} İstanbul Havalimanı Taksiciler Kooperatifi</p>
        <p>Powered by MuratSoft Yazılım</p>
      </footer>
    </div>
  );
};

export default Dashboard; 